import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/get-help")({
  beforeLoad: () => {
    throw redirect({ to: "/p/get-help" as never, replace: true });
  },
});
